var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-connected"},[_c('div',{attrs:{"id":"container"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('history-timeline')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }